import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  CardHeader,
  Table,
  Badge,
  Spinner,
  ListGroup,
  ListGroupItem,
  FormGroup,
  Label,
  Input,
  InputGroup,
  Alert,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from "react-router";
import { useContext, useEffect, useState } from "react";
import EnterpriseService from "../../common/services/enterprise-service";
import LoadingOverlay from "react-loading-overlay";
import { EnterpriseContext } from "./EnterpriseContext";
import Tips from "../Tips";
import { toast, ToastContainer } from "react-toastify";
import EnterpriseNavBar from "./EnterpriseNavBar";
import { faExchange } from "@fortawesome/free-solid-svg-icons";
import CustomBadge from "../ui/CustomBadge";
import UserDefinedUnits from "../../common/utils/UserDefinedUnits";
import BoxDynamicAd from "../../ads/BoxDynamicAd";
import truckyService from "../../common/services/trucky-service";
import VTCMenu from "../../web/components/VTCMenu";
import Breadcrumbs from "../../web/components/Breadcrumbs";
import reactSelectCustomStyles from "../../common/plugins/reactSelectStyles";
import Select from "react-select";
import ReactSelectUserOption from "../ui/ReactSelectUserOption";
import VehiclePlate from "./VehiclePlate";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { confirmWrapper } from "../ui/askConfirm";
import MaintenanceAlerts from "./MaintenanceAlerts";
import JobsTable from "./JobsTable";

const VehicleDetail = ({ container }) => {
  const { globalContext } = useContext(EnterpriseContext);

  const company = globalContext.company;
  const member = globalContext.member;

  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const es = new EnterpriseService();
  const [garages, setGarages] = useState([]);
  const [members, setMembers] = useState([]);
  const [mechanics, setMechanics] = useState([]);
  const [mechanic, setMechanic] = useState(0);
  const [membersIsLoading, setMembersIsLoading] = useState(false);
  const [jobsInProgress, setJobsInProgress] = useState([]);

  useEffect(() => {
    truckyService.setDocumentTitle("Vehicle Details");
  }, []);

  useEffect(() => {
    getVehicle();

    if (es.can(member, "vehicles.assign")) {
      getGarages();
      getMembers();
    }
  }, []);

  const getMechanics = async (vehicle) => {
    const result = await es.getGarageMechanics(company.id, vehicle.garage.id);
    setMechanics(result.filter((m) => m.skill == vehicle.maintenance_needed));
  };

  const getJobsInProgress = async () => {
    if (company == null) {
      return;
    }
    const es = new EnterpriseService();
    const jip = await es.getJobs(
      company,
      undefined,
      {
        perPage: 9999,
      },
      {
        status: "in_progress",
        vehicle_id: vehicle.id,
      },
    );
    if (jip.data) {
      setJobsInProgress(jip.data);
    }
  };

  const getVehicle = async () => {
    setLoading(true);
    const result = await es.getVehicle(company, id);
    setVehicle(result);

    if (
      es.can(member, "garages.maintenances") &&
      result != null &&
      result.status == "need_maintenance"
    ) {
      getMechanics(result);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (vehicle && vehicle.id) {
      getJobsInProgress();
    }
  }, [vehicle]);

  const getMembers = async () => {
    setMembersIsLoading(true);
    const result = await es.getMembers(company, {
      perPage: 9999,
    });
    setMembers(result.data);
    setMembersIsLoading(false);
  };

  const getGarages = async () => {
    const result = await es.getGarages(company);
    setGarages(result);
  };

  const submitEdit = async () => {
    const result = await es.updateVehicle(company, vehicle);
    if (result.success) {
      getVehicle();
      toast.success(container.localeManager.strings.vehicleUpdated);
    } else {
      toast.error(result.message);
    }
  };

  const getStatus = () => {
    if (vehicle.status == "active") {
      return (
        <CustomBadge color="success">
          <FontAwesomeIcon icon="check"></FontAwesomeIcon>
          {container.localeManager.strings.active}
        </CustomBadge>
      );
    }
    if (vehicle.status == "under_maintenance") {
      const maintenanceEnd = container.localeManager
        .moment(vehicle.maintenance_end_date)
        .local()
        .format("LLL");
      return (
        <>
          <CustomBadge color="danger">
            <FontAwesomeIcon icon="wrench"></FontAwesomeIcon>
            {container.localeManager.strings.under_maintenance} -{" "}
            {maintenanceEnd}
          </CustomBadge>
        </>
      );
    }
    if (vehicle.status == "need_maintenance") {
      return (
        <>
          <CustomBadge color="warning">
            <FontAwesomeIcon icon="wrench"></FontAwesomeIcon>
            {container.localeManager.strings.need_maintenance} -{" "}
            {container.localeManager.strings[vehicle.maintenance_needed]}
          </CustomBadge>
        </>
      );
    }
  };

  const startMaintenance = async () => {
    setLoading(true);
    const result = await es.assignVehicleToMechanic(company, {
      mechanic_id: mechanic,
      vehicle_id: vehicle.id,
      maintenance_type: vehicle.maintenance_needed,
    });
    if (result.success) {
      toast.success(container.localeManager.strings.maintenanceStarted);
    } else {
      toast.error(result.message);
    }
    getVehicle();
  };

  function getProgressBar(nextMaintenanceKm) {
    // Calculate the percentage
    let percentage = (vehicle.odometer_km / nextMaintenanceKm) * 100;

    let className = "bg-secondary";

    if (percentage > 80) {
      className = "bg-danger";
    } else if (percentage > 60) {
      className = "bg-warning";
    } else if (percentage > 40) {
      className = "bg-info";
    } else {
      className = "bg-success";
    }

    // Round to 2 decimal places
    return (
      <div class="position-relative mt-3">
        <div class="progress">
          <div
            className={`progress-bar progress-bar-animated ${className}`}
            role="progressbar"
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
        <div class="progress-bar-text mt-2">
          <div className="d-flex justify-content-between">
            <span></span>
            <span>
              {UserDefinedUnits.convertDistance(
                member,
                vehicle.game.id,
                nextMaintenanceKm,
              )}
            </span>
          </div>
        </div>
      </div>
    );
  }

  const getProgressBarUnfixable = (percentage) => {
    return (
      <div class="position-relative mt-3">
        <div class="progress">
          <div
            className={`progress-bar ${percentage}`}
            role="progressbar"
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
        <div class="progress-bar-text mt-2">
          {container.localeManager.numeral(percentage).format("0,0")}%
        </div>
      </div>
    );
  };

  const replacePart = async (part) => {
    if (
      await confirmWrapper(container.localeManager.strings.areYouSure, {
        container: container,
      })
    ) {
      const result = await es.replacePart(company, vehicle, part);
      if (result.success) {
        toast.success(container.localeManager.strings.maintenaceStarted);
        getVehicle();
      } else {
        toast.error(result.message);
      }
    }
  };

  const getUnfixableWearElement = (prop) => {
    return (
      <div className="grid cols-4">
        <div className="d-flex align-items-center">
          {container.localeManager.strings[prop]}
        </div>
        <div className="d-flex align-items-center">
          {vehicle.parts_to_replace &&
            vehicle.parts_to_replace.includes(prop) && (
              <>
                <FontAwesomeIcon
                  icon="exclamation-triangle"
                  className="text-danger me-2"
                ></FontAwesomeIcon>
                <span className="text-danger">
                  {container.localeManager.strings.replacePart}
                </span>
              </>
            )}
        </div>
        <div className="d-flex">
          <div className="w-300px me-5">
            {getProgressBarUnfixable(vehicle[`unfixable_${prop}_wear`])}
          </div>
        </div>
        {es.can(member, "garages.maintenances") && (
          <div className="d-flex justify-content-end">
            <Button
              title={container.localeManager.strings.replacePart}
              size="sm"
              className="border border-danger border-dashed w-100"
              color="active-light-success"
              onClick={() => replacePart(prop)}
              disabled={
                !vehicle.parts_to_replace ||
                !vehicle.parts_to_replace.includes(prop) ||
                vehicle[`unfixable_${prop}_wear`] < 10
              }
            >
              <FontAwesomeIcon icon="screwdriver-wrench"></FontAwesomeIcon>
              {container.localeManager
                .numeral(vehicle.component_replacement_costs[prop])
                .format("0,0")}{" "}
              T¢
            </Button>
          </div>
        )}
      </div>
    );
  };

  const sell = async () => {
    if (
      await confirmWrapper(container.localeManager.strings.sellVehicleConf, {
        container: container,
      })
    ) {
      setLoading(true);
      const result = await es.deleteVehicle(company, vehicle);
      if (result.success) {
        toast.success(container.localeManager.strings.vehicleSold);
        navigate("/vehicles");
      } else {
        toast.error(result.message);
      }
      setLoading(false);
    }
  };

  return (
    <LoadingOverlay
      active={loading}
      spinner={
        <Spinner
          color="primary"
          style={{ width: "4rem", height: "4rem" }}
        ></Spinner>
      }
    >
      <Row noGutters className="">
        <VTCMenu active={"/vehicles"} container={container}></VTCMenu>

        <Col>
          <Row noGutters>
            <Col>
              <Card className="h-100">
                <CardBody>
                  <Breadcrumbs
                    breadcrumbs={[
                      {
                        to: "/vtchub",
                        title: container.localeManager.strings.vtcHub,
                      },
                      {
                        to: "/vehicles",
                        title: container.localeManager.strings.fleet,
                      },
                      {
                        title: container.localeManager.strings.vehicle,
                      },
                    ]}
                  ></Breadcrumbs>
                  {vehicle != null && (
                    <>
                      {/* Vehicle Hero */}
                      <div className="vehicle-hero mb-4">
                        <img className="vehicle-hero-brand" src={vehicle.model.brand.logo_url} alt="brand" />
                        <div className="vehicle-hero-info">
                          <div className="vehicle-hero-name">#{vehicle.id} · {vehicle.vehicle_name}</div>
                          <div className="vehicle-hero-model text-muted">{vehicle.model.brand.name} — {vehicle.game?.code}</div>
                          <VehiclePlate container={container} vehicle={vehicle} />
                          <div className="mt-2">{getStatus()}</div>
                        </div>
                        <img className="vehicle-hero-photo" src={vehicle.model.photo_url} alt="model" />
                      </div>
                      <Row>
                        {es.can(member, "vehicles.assign") && (
                          <Col>
                            <div className="filters-toolbar mb-3">
                              <Row className="g-3">
                                <Col md={3}>
                                  <Label>{container.localeManager.strings.fleetNumber}</Label>
                                  <Input
                                    onChange={(e) => setVehicle({ ...vehicle, edited: true, fleet_number: e.target.value })}
                                    value={vehicle.fleet_number}
                                    maxLength={6}
                                  />
                                </Col>
                                {garages.length > 0 && (
                                  <>
                                    <Col md={3}>
                                      <Label>{container.localeManager.strings.moveToGarage}</Label>
                                      <Input value={vehicle.garage_id} type="select" onChange={(e) => setVehicle({ ...vehicle, edited: true, garage_id: e.target.value })}>
                                        {garages.map((g) => <option key={g.id} value={g.id}>{g.city.name}</option>)}
                                      </Input>
                                    </Col>
                                    <Col md={4}>
                                      <Label>{container.localeManager.strings.assignToUser}</Label>
                                      <Select
                                        styles={reactSelectCustomStyles}
                                        value={members.find((m) => m.id === vehicle.assigned_to_user_id) || null}
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        options={members}
                                        isClearable={true}
                                        onChange={(e) => setVehicle({ ...vehicle, edited: true, assigned_to_user_id: e ? e.id : null })}
                                        isLoading={membersIsLoading}
                                        isDisabled={membersIsLoading || (jobsInProgress && jobsInProgress.length > 0)}
                                        components={{ Option: ReactSelectUserOption }}
                                      />
                                    </Col>
                                    <Col md={2} className="d-flex align-items-end gap-2">
                                      <Button size="sm" onClick={submitEdit} color="success">
                                        <FontAwesomeIcon icon="check" />{container.localeManager.strings.save}
                                      </Button>
                                      {es.can(member, "vehicles.sell") && (
                                        <Button size="sm" onClick={sell} color="danger" disabled={jobsInProgress && jobsInProgress.length > 0}>
                                          <FontAwesomeIcon icon="times" />{container.localeManager.strings.sell}
                                        </Button>
                                      )}
                                    </Col>
                                  </>
                                )}
                              </Row>
                            </div>
                          </Col>
                        )}
                      </Row>
                      {es.can(member, "garages.maintenances") &&
                        vehicle.status == "need_maintenance" &&
                        vehicle.maintenance_needed != "replace_parts" && (
                          <div className="mt-3">
                            <FormGroup row>
                              <Label sm="auto">
                                {container.localeManager.strings.mechanics}
                              </Label>
                              <Col sm={6}>
                                <Input
                                  onChange={(e) => setMechanic(e.target.value)}
                                  type="select"
                                >
                                  <option value="0">
                                    {
                                      container.localeManager.strings
                                        .assignVehicleMechanic
                                    }
                                  </option>
                                  {mechanics.map((m) => {
                                    return (
                                      <option
                                        disabled={m.vehicle_id != null}
                                        value={m.id}
                                      >
                                        {m.name} -{" "}
                                        {container.localeManager.strings.speed}:{" "}
                                        {m.speed}
                                      </option>
                                    );
                                  })}
                                </Input>
                              </Col>
                              <Col sm="auto">
                                <Button
                                  disabled={mechanic == 0}
                                  size="sm"
                                  onClick={startMaintenance}
                                  color="warning"
                                >
                                  {
                                    container.localeManager.strings
                                      .startMaintenance
                                  }
                                </Button>
                              </Col>
                            </FormGroup>
                          </div>
                        )}
                      {jobsInProgress && jobsInProgress.length > 0 && (
                        <div className="mt-3">
                          <Alert color="warning">
                            <FontAwesomeIcon
                              icon={faExchange}
                              className="me-2"
                            ></FontAwesomeIcon>
                            {
                              container.localeManager.strings
                                .vehicleHasJobsInProgress
                            }
                          </Alert>
                        </div>
                      )}
                      {/* Driver + Garage */}
                      <Row className="g-3 mt-1 mb-3">
                        <Col md={6}>
                          <Card className="h-100">
                            <CardBody className="d-flex align-items-center gap-3">
                              <div className="page-title-icon page-title-icon-info">
                                <FontAwesomeIcon icon="user" className="mx-0" />
                              </div>
                              <div>
                                <div className="text-muted small text-uppercase fw-bold mb-1">{container.localeManager.strings.driver}</div>
                                {vehicle.driver != null ? (
                                  <div className="d-flex align-items-center gap-2">
                                    <img src={vehicle.driver.avatar_url} className="rounded" style={{ width: 32, height: 32, objectFit: 'cover' }} />
                                    <Link to={`/user/${vehicle.driver.id}`} className="fw-bold">{vehicle.driver.name}</Link>
                                  </div>
                                ) : (
                                  <span className="text-muted fst-italic">{container.localeManager.strings.notAssigned}</span>
                                )}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="h-100">
                            <CardBody className="d-flex align-items-center gap-3">
                              <div className="page-title-icon page-title-icon-success">
                                <FontAwesomeIcon icon="warehouse" className="mx-0" />
                              </div>
                              <div>
                                <div className="text-muted small text-uppercase fw-bold mb-1">{container.localeManager.strings.garage}</div>
                                <Link to={`/garage/${vehicle.garage.id}`} className="fw-bold">
                                  {vehicle.garage.city.name}
                                </Link>
                                <div className="text-muted small">{vehicle.garage.vehicles_count} / {vehicle.garage.max_vehicles} {container.localeManager.strings.vehicles}</div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      {/* Odometer / Price / Date */}
                      <Row className="g-3 mb-3">
                        <Col md={4}>
                          <div className="stat-tile stat-tile-primary stat-tile-with-icon">
                            <div className="stat-tile-icon"><FontAwesomeIcon icon="gauge" className="mx-0" /></div>
                            <div className="stat-tile-body">
                              <div className="stat-tile-label fw-bold text-uppercase">{container.localeManager.strings.odometer}</div>
                              <div className="counted fs-4">{UserDefinedUnits.convertDistance(member, vehicle.model.game_id, vehicle.odometer_km)}</div>
                            </div>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="stat-tile stat-tile-success stat-tile-with-icon">
                            <div className="stat-tile-icon"><FontAwesomeIcon icon="piggy-bank" className="mx-0" /></div>
                            <div className="stat-tile-body">
                              <div className="stat-tile-label fw-bold text-uppercase">{container.localeManager.strings.price}</div>
                              <div className="counted fs-4">
                                {vehicle.used_purchase_price != null ? (
                                  <>{container.localeManager.numeral(vehicle.used_purchase_price).format("0,0")} {vehicle.company.currency} <span className="text-muted fs-6"><strike>{container.localeManager.numeral(vehicle.price).format("0,0")}</strike></span></>
                                ) : (
                                  <>{container.localeManager.numeral(vehicle.price).format("0,0")} {vehicle.company.currency}</>
                                )}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="stat-tile stat-tile-info stat-tile-with-icon">
                            <div className="stat-tile-icon"><FontAwesomeIcon icon="calendar" className="mx-0" /></div>
                            <div className="stat-tile-body">
                              <div className="stat-tile-label fw-bold text-uppercase">{container.localeManager.strings.boughtOn}</div>
                              <div className="counted fs-5">{container.localeManager.moment(vehicle.created_at).format("l")}</div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <div>
                        <Card>
                          <CardHeader>
                            {container.localeManager.strings.unfixableDamage}
                          </CardHeader>
                          <CardBody>
                            {getUnfixableWearElement("engine")}
                            {getUnfixableWearElement("transmission")}
                            {getUnfixableWearElement("brakes")}
                            {getUnfixableWearElement("electronics")}
                          </CardBody>
                        </Card>
                      </div>
                      {/* Stats + Next Maintenance */}
                      <Row className="g-3 mb-3">
                        <Col md={6}>
                          <Card className="h-100">
                            <CardBody>
                              <h6 className="mb-3">
                                <span className="page-title-icon page-title-icon-sm page-title-icon-warning me-2"><FontAwesomeIcon icon="chart-bar" className="mx-0" /></span>
                                {container.localeManager.strings.statistics}
                              </h6>
                              <ListGroup flush>
                                <ListGroupItem>
                                  {container.localeManager.strings.revenue}
                                  <span className="float-end fw-bold">
                                    {container.localeManager.numeral(vehicle.total_revenue).format("0,0")} {vehicle.company.currency}
                                  </span>
                                </ListGroupItem>
                                <ListGroupItem>
                                  {container.localeManager.strings.fuelUsed}
                                  <span className="float-end fw-bold">
                                    {UserDefinedUnits.convertVolume(member, null, vehicle.total_fuel_used_l)}
                                  </span>
                                </ListGroupItem>
                                <ListGroupItem>
                                  {container.localeManager.strings.damageCost}
                                  <span className="float-end fw-bold">
                                    {container.localeManager.numeral(vehicle.total_damage_cost).format("0,0")} {vehicle.company.currency}
                                  </span>
                                </ListGroupItem>
                              </ListGroup>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="h-100">
                            <CardBody>
                              <h6 className="mb-3">
                                <span className="page-title-icon page-title-icon-sm page-title-icon-danger me-2"><FontAwesomeIcon icon="wrench" className="mx-0" /></span>
                                {container.localeManager.strings.nextMaintenance}
                              </h6>
                              <ListGroup flush>
                                <ListGroupItem>
                                  {container.localeManager.strings.general}
                                  {getProgressBar(vehicle.next_maintenance.general)}
                                </ListGroupItem>
                                <ListGroupItem>
                                  {container.localeManager.strings.tires}
                                  {getProgressBar(vehicle.next_maintenance.tires)}
                                </ListGroupItem>
                                <ListGroupItem>
                                  {container.localeManager.strings.engine}
                                  {getProgressBar(vehicle.next_maintenance.engine)}
                                </ListGroupItem>
                              </ListGroup>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {vehicle.maintenances &&
                            vehicle.maintenances.length > 0 && (
                              <>
                                <h5 className="mt-3">
                                  {
                                    container.localeManager.strings
                                      .maintenanceEvents
                                  }
                                </h5>
                                <Table
                                  responsive
                                  striped
                                  size="sm"
                                  className="table-row-dashed table-row-gray-300 align-middle gs-0"
                                  hover
                                >
                                  <thead>
                                    <tr className="fw-bolder text-gray-700 bg-light">
                                      <th scope="col" className="ps-4">
                                        {container.localeManager.strings.date}
                                      </th>
                                      <th scope="col">
                                        {container.localeManager.strings.type}
                                      </th>
                                      <th scope="col">
                                        {container.localeManager.strings.price}
                                      </th>
                                      <th scope="col">
                                        {
                                          container.localeManager.strings
                                            .odometer
                                        }
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {vehicle.maintenances.map((m) => {
                                      return (
                                        <tr>
                                          <td className="ps-2">
                                            {container.localeManager
                                              .moment(m.created_at)
                                              .format("l")}
                                          </td>
                                          <td>
                                            {
                                              container.localeManager.strings[
                                                m.type
                                              ]
                                            }
                                          </td>
                                          <td>
                                            {container.localeManager
                                              .numeral(m.price)
                                              .format("0,0")}{" "}
                                            {m.currency}
                                          </td>
                                          <td>
                                            {UserDefinedUnits.convertDistance(
                                              member,
                                              vehicle.model.game_id,
                                              m.odometer_km,
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </>
                            )}
                          {jobsInProgress.length > 0 && (
                            <>
                              <h5 className="mt-3">
                                {
                                  container.localeManager.strings
                                    .jobs_in_progress_count
                                }
                              </h5>
                              <JobsTable
                                jobs={jobsInProgress}
                                container={container}
                              ></JobsTable>
                            </>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
            <aside className="ad-column-placeholder">
              <Tips localeManager={container.localeManager}></Tips>
              <MaintenanceAlerts
                container={container}
                company={company}
              ></MaintenanceAlerts>
              {!window.overwolf && (
                <BoxDynamicAd container={container} className="my-3" />
              )}
            </aside>
          </Row>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Col>
      </Row>
    </LoadingOverlay>
  );
};

export default VehicleDetail;
